import { useCallback, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import HeaderComponent from "../header";
import AppTabsComponent from '../shared/appTabsComponent'
import { manageAcntFeatures } from "../featuresList";
const tabs = [
    { key: "1", name: "Personal Profile", path: "/profile/personalInfo" },
    { key: "2", name: "Change Password", path: "/profile/changePassword" },
    { key: "3", name: "Authenticator App", path: "/profile/authenticatorApp" },
    { key: "4", name: "KYB", path: "/profile/kyb" }
];
const ProfileTabs = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const activeTab = tabs.find(tab => tab.path === location.pathname)?.key || "1";
    useEffect(() => {
        handleTabChange(activeTab)
    }, [])
    const handleTabChange = useCallback((key) => {
        const selectedTab = tabs.find(tab => tab.key === key);
        if (selectedTab) navigate(selectedTab.path);
    }, [])

    const breadCrumbList = [
        { id: 1, bname: "Manage Account" },
        { id: 2, bname: tabs.find(tab => tab.key === activeTab)?.name }
    ];
    return (
        <>
            <HeaderComponent breadCrumbList={breadCrumbList} />
            <div className='profile-tabs  md:flex gap-0.5'>
                <AppTabsComponent serviceName={"CardsManageService.ManageAccount"} isNoRouting={false} tabPosition={"left"} staticmenuData={manageAcntFeatures()} />
                <div className="md:w-[77%] w-full border border-StrokeColor md:p-4 p-2 rounded-5">
                    <Outlet />
                </div>
            </div>
        </>
    )
}
export default ProfileTabs